export const removeAccents = (value: string): string => {
  // Normalize the string using Unicode normalization
  const normalizedStr = value.normalize('NFD');

  // Use a regular expression to remove accents and diacritics
  return normalizedStr.replace(/[\u0300-\u036f]/g, '');
};
